var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass:
        "bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
    },
    [
      _c("div", { staticClass: "hidden sm:block" }, [
        _c("p", { staticClass: "text-sm leading-5 text-gray-700" }, [
          _vm._v(" Showing "),
          _c("span", { staticClass: "font-medium" }, [
            _vm._v(_vm._s(_vm.startingPagerValue) + " ")
          ]),
          _vm._v(" to "),
          _c("span", { staticClass: "font-medium" }, [
            _vm._v(_vm._s(_vm.pagerValue) + " ")
          ]),
          _vm._v(" of "),
          _c("span", { staticClass: "font-medium" }, [
            _vm._v(_vm._s(_vm.page.total) + " ")
          ]),
          _vm._v(" results ")
        ])
      ]),
      _c("div", { staticClass: "flex-1 flex justify-between sm:justify-end" }, [
        _vm.page.page - 1 >= 1
          ? _c(
              "a",
              {
                staticClass:
                  "relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150",
                on: { click: _vm.loadPrevPage }
              },
              [_vm._v(" Previous ")]
            )
          : _vm._e(),
        _vm.page.pages > _vm.page.page
          ? _c(
              "a",
              {
                staticClass:
                  "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150",
                on: { click: _vm.loadNextPage }
              },
              [_vm._v(" Next ")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }